import React from 'react';
import Image from '@material-ui/icons/Image';
import CropLandscape from '@material-ui/icons/CropLandscape';
import StarIcon from '@material-ui/icons/Star';
import FormatShapesIcon from '@material-ui/icons/FormatShapes';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import CropSquare from '@material-ui/icons/CropSquare';
import { ReactComponent as HotSpotIcon } from '../assets/images/hotspot_icon_widget.svg';
import CodeIcon from '@material-ui/icons/Code';

export const PLAYER_IFRAME_ID = 'scene-editor-preview-player';
export const EDITOR_PLAYER_ID = 'player-for-editor';
export const EDITOR_QPLAYER_IDENTIFIER = 'Qplayer.Editor';
export const QPLAYER_IDENTIFIER = 'Qplayer';

export const POST_MESSAGE_TYPE = {
	scenario: 'updateScenario',
	scene: 'updateScene',
};

export const ACTION_GO_TO_SCENE = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_GO_TO_SCENE',
	value: 'goToScene',
};

export const ACTION_LOOP_CURRENT_SCENE = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_LOOP_CURRENT_SCENE',
	value: 'loopCurrentScene',
};

export const ACTION_GO_TO_HOME = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_GO_TO_HOME',
	value: 'goToHome',
};

export const ACTION_GO_TO_URL = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_GO_TO_URL',
	value: 'goToUrl',
};

export const ACTION_JUMP_TO_TIME = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_JUMP_TO_TIME',
	value: 'jumpToTime',
};

export const ACTION_PAUSE = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_PAUSE',
	value: 'pause',
};

export const ACTION_PLAY = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_SCENE_ACTION_PLAY',
	value: 'play',
};

export const sceneActions = [ACTION_GO_TO_SCENE, ACTION_LOOP_CURRENT_SCENE, ACTION_GO_TO_HOME];

export const widgetClickActions = [ACTION_GO_TO_SCENE, ACTION_GO_TO_URL, ACTION_JUMP_TO_TIME, ACTION_PAUSE, ACTION_PLAY];
export const widgetEntryActions = [ACTION_PAUSE, ACTION_PLAY, ACTION_JUMP_TO_TIME];
export const widgetExitActions = [ACTION_PAUSE, ACTION_PLAY, ACTION_JUMP_TO_TIME];

export const WIDGET_EVENT_ENTRY = 'onEntry';
export const WIDGET_EVENT_CLICK = 'onClick';
export const WIDGET_EVENT_EXIT = 'onExit';

export const WIDGET_EVENTS = {
	[WIDGET_EVENT_CLICK]: {
		actions: widgetClickActions,
		icon: <OpenInNewIcon htmlColor="#CDD4D9" />,
		label: 'SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ACTION_ON_CLICK',
		rank: 0,
	},
	[WIDGET_EVENT_ENTRY]: {
		actions: widgetEntryActions,
		icon: <ArrowForwardIcon htmlColor="#CDD4D9" />,
		label: 'SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ACTION_ON_ENTRY',
		rank: 1,
	},
	[WIDGET_EVENT_EXIT]: {
		actions: widgetExitActions,
		icon: <ArrowForwardIcon htmlColor="#CDD4D9" />,
		label: 'SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ACTION_ON_EXIT',
		rank: 2,
	},
};

export const TRANSITION_NONE = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_TRANSITION_EFFECT_NONE',
	value: 'none',
};

export const TRANSITION_FADE_IN = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_TRANSITION_EFFECT_FADE_IN',
	value: 'fade-in',
};

export const TRANSITION_FADE_OUT = {
	label: 'SCENARIO_STORYBOARD_SCENE_SETTING_TRANSITION_EFFECT_FADE_OUT',
	value: 'fade-out',
};

export const TIMELINE_VISIBILITY_PRESET_INHERIT = {
	label: 'SCENARIO_STORYBOARD_SCENE_TIMELINE_VISIBILITY_PRESET_INHERIT',
	value: 'inherit',
};

export const TIMELINE_VISIBILITY_VISIBLE = {
	label: 'SCENARIO_STORYBOARD_SCENE_TIMELINE_VISIBILITY_VISIBLE',
	value: 'visible',
};

export const TIMELINE_VISIBILITY_HIDDEN = {
	label: 'SCENARIO_STORYBOARD_SCENE_TIMELINE_VISIBILITY_HIDDEN',
	value: 'hidden',
};

export const sceneTransitionInEffects = [TRANSITION_NONE, TRANSITION_FADE_IN];

export const sceneTransitionOutEffects = [TRANSITION_NONE, TRANSITION_FADE_OUT];

export const sceneTimelineVisibility = [
	TIMELINE_VISIBILITY_PRESET_INHERIT,
	TIMELINE_VISIBILITY_VISIBLE,
	TIMELINE_VISIBILITY_HIDDEN,
];

export const positions = [
	{
		value: 'center',
		label: 'Center',
	},
	{
		value: 'top-left',
		label: 'Top left',
	},
	{
		value: 'left',
		label: 'Left',
	},
	{
		value: 'bottom-left',
		label: 'Bottom left',
	},
	{
		value: 'middle-bottom',
		label: 'Middle bottom',
	},
	{
		value: 'bottom-right',
		label: 'Bottom right',
	},
	{
		value: 'right',
		label: 'Right',
	},
	{
		value: 'top-right',
		label: 'Top right',
	},
	{
		value: 'middle-top',
		label: 'Middle top',
	},
];

export const TABS = ['General', 'Edit (Main menu)'];

export const transformKeys = { paddingTop: 'top', paddingRight: 'right', paddingBottom: 'bottom', paddingLeft: 'left' };

export const BorderRadiusKeys = {
	borderRadiusTop: 'top right',
	borderRadiusRight: 'bottom right',
	borderRadiusBottom: 'bottom left',
	borderRadiusLeft: 'top left',
};

export const TextRadiusKeys = {
	radiusTop: 'top right',
	radiusRight: 'bottom right',
	radiusBottom: 'bottom left',
	radiusLeft: 'top left',
};

export const DEFAULT_LAYOUT_TEMPLATE = {
	id: '0001',
	boxes: [
		{
			id: '1',
			name: 'Box 1',
			isBackground: true,
		},
	],
};

export const DEFAULT_LAYOUT = {
	layoutTemplateId: '0001',
	boxes: [
		{
			boxTemplateId: '1',
			settings: { transition: 'fade-in' },
		},
	],
};

export const DEFAULT_SCENE_DATA = {
	transitionIn: 'fade-in',
	duration: {
		enabled: false,
		value: undefined,
	},
};

export const DEFAULT_WIDGETS_DATA = {
	events: [],
	style: {
		fill: 'fit-box',
		position: 'center',
		textLabel: {
			font: 'Poppins',
			fontSize: '12',
			fontWeight: 'normal',
			color: '#126cfc',
			backgroundColor: 'transparent',
			hoverFontWeight: 'normal',
			hoverColor: '#126cfc',
			hoverBackgroundColor: 'transparent',
		},
		backgroundSettings: {
			backgroundColor: 'transparent',
			hoverBackgroundColor: 'transparent',
		},
		transformSettings: {
			borderRadiusTop: '0',
			borderRadiusBottom: '0',
			borderRadiusRight: '0',
			borderRadiusLeft: '0',
			radiusTop: '0',
			radiusBottom: '0',
			radiusRight: '0',
			radiusLeft: '0',
			paddingTop: '0',
			paddingBottom: '0',
			paddingRight: '0',
			paddingLeft: '0',
			hoverRadiusTop: '0',
			hoverRadiusBottom: '0',
			hoverRadiusRight: '0',
			hoverRadiusLeft: '0',
			hoverPaddingTop: '0',
			hoverPaddingBottom: '0',
			hoverPaddingRight: '0',
			hoverPaddingLeft: '0',
		},
	},
};

export const WIDGET_TYPE_VIDEO = 'video';
export const WIDGET_TYPE_IMAGE = 'image';
export const WIDGET_TYPE_BUTTON = 'button';
export const WIDGET_TYPE_ICON = 'icon';
export const WIDGET_TYPE_TEXT = 'text';
export const WIDGET_TYPE_HOTSPOT = 'hotspot';
export const WIDGET_TYPE_IFRAME = 'iframe';
export const WIDGET_TYPE_SHAPE = 'shape';

export const WIDGET_TYPES = {
	WIDGET_TYPE_VIDEO,
	WIDGET_TYPE_IMAGE,
	WIDGET_TYPE_BUTTON,
	WIDGET_TYPE_ICON,
	WIDGET_TYPE_TEXT,
	WIDGET_TYPE_HOTSPOT,
	WIDGET_TYPE_IFRAME,
	WIDGET_TYPE_SHAPE,
};

export const SHAPE_TYPES_LIST = [
	"rectangle",
	"circle",
	"triangle",
];

export const WIDGETS_TYPE_LIST = [
	{ type: WIDGET_TYPE_ICON, icon: <StarIcon /> },
	{
		type: WIDGET_TYPE_IMAGE,
		icon: <Image />,
	},
	{
		type: WIDGET_TYPE_BUTTON,
		icon: <CropLandscape />,
	},
	{
		type: WIDGET_TYPE_TEXT,
		icon: <FormatShapesIcon />,
	},
	{
		type: WIDGET_TYPE_HOTSPOT,
		icon: <HotSpotIcon style={{ width: 36, height: 27 }} />,
	},
	{
		type: WIDGET_TYPE_IFRAME,
		icon: <CodeIcon />,
	},
	{
		type: WIDGET_TYPE_SHAPE,
		icon: <CropSquare />,
	},
];

export const WIDGET_SHORT_NAME = {
	[WIDGET_TYPE_IMAGE]: 'img',
	[WIDGET_TYPE_BUTTON]: 'btn',
	[WIDGET_TYPE_SHAPE]: 'shape',
	[WIDGET_TYPE_ICON]: 'icon',
	[WIDGET_TYPE_TEXT]: 'text',
	[WIDGET_TYPE_HOTSPOT]: 'hotspot',
	[WIDGET_TYPE_IFRAME]: 'iframe',
};

export const WIDGET_NAME_TRANSLATE_LABEL = {
	[WIDGET_TYPE_VIDEO]: "COMMON_MEDIA_TYPE_VIDEO",
	[WIDGET_TYPE_IMAGE]: "COMMON_MEDIA_TYPE_IMAGE",
	[WIDGET_TYPE_BUTTON]: "COMMON_MEDIA_TYPE_BUTTON",
	[WIDGET_TYPE_SHAPE]: "COMMON_MEDIA_TYPE_SHAPE",
	[WIDGET_TYPE_ICON]: "COMMON_MEDIA_TYPE_ICON",
	[WIDGET_TYPE_TEXT]: "COMMON_MEDIA_TYPE_TEXT",
	[WIDGET_TYPE_HOTSPOT]: "COMMON_MEDIA_TYPE_HOTSPOT",
	[WIDGET_TYPE_IFRAME]: "COMMON_MEDIA_TYPE_IFRAME",
	name: "Widget",
};

export const WIDGET_ANIMATION_TYPES = {
	[WIDGET_TYPE_TEXT]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX', 'wordsFade', 'wordsSlide', 'charactersFade', 'typewriter'],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX', 'wordsFade', 'wordsSlide', 'charactersFade', 'typewriter'],
	},
	[WIDGET_TYPE_BUTTON]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX', "pillIn", "squareIn"],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX', "pillOut", "squareOut"],
	},
	[WIDGET_TYPE_SHAPE]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX', "pillIn", "squareIn"],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX', "pillOut", "squareOut"],
	},
	[WIDGET_TYPE_IMAGE]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX'],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX'],
	},
	[WIDGET_TYPE_ICON]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX', "pillIn", "squareIn"],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX', "pillOut", "squareOut"],
	},
	[WIDGET_TYPE_HOTSPOT]: {
		entry: ['fadeIn', 'slideIn', 'zoomIn', 'slideAndFade', 'bounceIn', 'flipInX', "pillIn", "squareIn"],
		loop: ['pulse'],
		exit: ['fadeOut', 'slideOut', 'zoomOut', 'slideAndFade', 'bounceOut', 'flipOutX', "pillOut", "squareOut"],
	},
};

export const WIDGET_ANIMATION_TYPE_HAS_DIRECTION = ['slideIn', 'slideOut', 'slideAndFade', "bounceIn", "bounceOut"];
export const WIDGET_ANIMATION_TYPE_HAS_NO_DURATION = ['typewriter'];

export const WIDGET_ANIMATION_DIRECTIONS = [
	{
		value: "Down",
		label: "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_DIRECTION_DOWN",
	},
	{
		value: "Up",
		label: "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_DIRECTION_UP",
	},
	{
		value: "Left",
		label: "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_DIRECTION_LEFT",
	},
	{
		value: "Right",
		label: "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_DIRECTION_RIGHT",
	},
]

export const WIDGET_ANIMATION_TYPE_TRANSLATE_LABELS = {
	entry: {
		'fadeIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_FADE",
		'slideIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_SLIDE",
		'zoomIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_SCALE",
		'slideAndFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_SLIDE_AND_FADE",
		'bounceIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_BOUNCE",
		'flipInX': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_FLIP",
		'typewriter': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_TYPEWRITER",
		'wordsFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_WORDS_FADE",
		'wordsSlide': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_WORDS_SLIDE",
		'charactersFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_CHARACTERS_FADE",
		'pillIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_PILL",
		'squareIn': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_ENTRY_SQUARE",
	},
	loop: {
		'pulse': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_LOOP_PULSE",
	},
	exit: {
		'fadeOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_FADE",
		'slideOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_SLIDE",
		'zoomOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_SCALE",
		'slideAndFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_SLIDE_AND_FADE",
		'bounceOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_BOUNCE",
		'flipOutX': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_FLIP",
		'typewriter': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_TYPEWRITER",
		'wordsFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_WORDS_FADE",
		'wordsSlide': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_WORDS_SLIDE",
		'charactersFade': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_CHARACTERS_FADE",
		'pillOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_PILL",
		'squareOut': "SCENARIO_SCENE_EDITOR_WIDGET_SETTING_ANIMATION_EXIT_SQUARE",
	},
};